import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const IPAddressManagementTable = styled.table`
  position: relative;
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  min-height: 430px;
  grid-template-columns: 4fr 3fr 0.5fr;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  grid-auto-rows: min-content;
  border-radius: 5px;
  padding: 10px;
`;

export const IPAddressManagementTableHead = styled.thead`
  display: contents;
`;
export const IPAddressManagementTableBody = styled.tbody`
  display: contents;
`;
export const IPAddressManagementTableTR = styled.tr`
  display: contents;
`;
export const IPAddressManagementTableTD = styled.td`
  display: flex;
  align-items: center;
  padding: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primaryText};
`;
export const IPAddressManagementTableTH = styled.th`
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: sticky;
  top: 0;
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const NameContainer = styled(Box)`
  max-width: 175px;
`;
